import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontWeight: 'bold',
    },
    description: {
        width: '85%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });


const InvoiceTableFooter = ({items}) => {
    var total = 0
    const urlParams = new URLSearchParams(window.location.search);
    const entityType = urlParams.get('type');
    entityType === '1' ? 
    total = items.map(item => item.quote.dealerPrice)
        .reduce((accumulator, currentValue) => accumulator + currentValue , 0)
        :
        total = items.map(item => item.quote.transporterPrice)
        .reduce((accumulator, currentValue) => accumulator + currentValue , 0)

    return(
        <View style={styles.row}>
            <Text style={styles.description}>TOTAL</Text>
            <Text style={styles.total}>${total}</Text>
        </View>
    )
};

  export default InvoiceTableFooter
